<template lang="pug">
  v-container(fluid)
    h2.text-center {{translations.title}} usuario de ejemplo

    v-row.px-10.pb-10( justify="center")
      v-col(cols="12")
        v-simple-table
          template(default)
            thead
              tr
                th {{translations.tableHeadText.date}}
                th {{translations.tableHeadText.gameId}}
                th {{translations.tableHeadText.quantity}}
                th {{translations.tableHeadText.transactionType}}
                th
            tbody
              tr(v-for="(transaction,i) in 15" :key="i")
                td {{transaction}}/03/2020
                td 3545{{transaction}}
                td {{transaction}}
                td Full
                td
                  v-btn(text) {{translations.button}}
</template>

<script>
  export default {
    name: "UsersInfo",
    computed:{
      translations(){
        return this.$t("views.usersInfo");
      },
    }
  }
</script>

<style lang="sass">
</style>